__turbopack_context__.v({
  "button": "Button-module-scss-module__gW1A4G__button",
  "button__icon": "Button-module-scss-module__gW1A4G__button__icon",
  "button__time": "Button-module-scss-module__gW1A4G__button__time",
});
